import { DEVLINK_COMPONENT_CONFIGS } from "./constants/devlink-component-types";
/**
 * Dynamically generates default props for all Devlink components.
 * Reads from DEVLINK_COMPONENT_CONFIGS as single source of truth.
 * Creates lowercase component keys matching runtime behavior.
 * 
 * Example result: { componentType: "Departments", departments: {...}, products: {...}, aiagents: {...} }
 */ const buildDevlinkDefaultProps = ()=>{
    const defaultProps = {
        componentType: "Departments"
    };
    Object.entries(DEVLINK_COMPONENT_CONFIGS).forEach(([componentName, config])=>{
        if (config.defaultProps) {
            const componentKey = componentName.toLowerCase();
            defaultProps[componentKey] = config.defaultProps;
        }
    });
    return defaultProps;
};
export default {
    devlinkComponent: buildDevlinkDefaultProps()
};
